export default __webpack_public_path__ + "static/media/AWSDark.b6e2edeb.svg";